import React, {ComponentProps} from 'react';

import {MoneyBackMini, Icon} from '@optimaxdev/icons';

import {useFeature} from 'components/feature';
import {Price} from 'components/price/price';

import {RebateOffer} from '../rebateOffer/rebateOffer';

import s from './rebateTotal.scss';

export type PropsType = {
    currentRebateDiscount: number | null;
    rebateTotalPrice: number | null;
    isPLA?: boolean;
    className?: string;
    type?: 'default' | 'blue';
    eventName: ComponentProps<typeof RebateOffer>['eventName'];
    cartNewUI?: boolean;
};

/**
 * renders rebate current rebate discount and total with rebate
 *  @returns {React.ReactElement} - Rebate total
 */
export const RebateTotal: React.FC<PropsType> = ({
    className = '',
    currentRebateDiscount,
    eventName,
    isPLA = false,
    rebateTotalPrice,
}) => {
    const isClRebate = useFeature('clRebate');
    if (!currentRebateDiscount || !rebateTotalPrice || isPLA || !isClRebate) return null;

    return (
        <div className={className}>
            <div className={s.rebateCount}>
                <span>
                    <span className={s.rebateIcon}>
                        <Icon icon={MoneyBackMini} />
                    </span>
                    Rebate:
                </span>
                <span className={s.rebatePrice}>
                    -<Price>{currentRebateDiscount}</Price>
                </span>
            </div>
            <RebateOffer eventName={eventName} total={rebateTotalPrice}>
                Total after mail-in rebate
            </RebateOffer>
        </div>
    );
};
